@if (variant() === 'small') {
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 30 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-label="FR8BOT"
  >
    <path
      d="M0 20.0002H6.14858V13.3336H20.1423L24.1739 8.00024H6.11335V5.33358H26.1897L30.2213 0.000244141H0V20.0002Z"
      fill="#C1D91C"
    />
  </svg>
} @else {
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 169 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-label="FR8BOT"
  >
    <path
      d="M-0.000244141 20.0005H6.11217V13.3338H18.0353L22.0432 8.00049H6.07714V5.33382H24.0472L28.0551 0.000488281H-0.000244141V20.0005Z"
      fill="#C1D91C"
    />
    <path
      d="M48.3105 13.4829C51.0606 12.9706 53.0528 10.2667 52.9809 7.14552C52.9809 1.43662 47.8574 0.000488281 43.8005 0.000488281H32.731L28.7231 5.33382H46.1463C46.7949 5.33434 47.4267 5.94057 47.4267 6.66716C47.4262 7.39374 46.7949 8.00101 46.1463 8.00049H28.7231V20L34.067 20.0005V13.3338H41.7488L46.7124 20.0005H54.1065L50.8199 16.1145C50.0437 15.1674 49.2048 14.288 48.3105 13.4829Z"
      fill="#C1D91C"
    />
    <path
      d="M79.7583 9.71669H79.7538C81.4558 9.08506 82.5488 7.38177 82.4394 5.53128C82.4394 1.85407 79.4332 0.000488281 74.7633 0.000488281H65.5102C60.8398 0.000488281 57.833 1.85407 57.833 5.53128C57.7236 7.38177 58.8166 9.08506 60.5186 9.71669C58.6089 10.2889 57.3375 12.1363 57.4539 14.1712C57.4539 17.49 59.2048 20.0005 65.366 20.0005H74.9105C81.0691 20.0005 82.8225 17.4889 82.8225 14.1712C82.939 12.1368 81.6681 10.2894 79.7583 9.71669ZM65.2475 5.20281H75.0254C75.8719 5.20281 76.6891 5.50184 76.6891 6.48829C76.6891 7.50468 75.9006 7.83367 75.0254 7.83367H65.2475C64.3718 7.83367 63.5838 7.50468 63.5838 6.48829C63.5838 5.50184 64.4026 5.20281 65.2475 5.20281ZM74.9382 14.8596H65.3347C64.0502 14.8596 63.4664 14.3809 63.4664 13.4538C63.4664 12.5867 64.0502 12.1089 65.3347 12.1089H74.9382C76.2228 12.1089 76.8066 12.5877 76.8066 13.4538C76.8061 14.3809 76.2223 14.8596 74.9382 14.8596Z"
      fill="#C1D91C"
    />
    <path
      d="M108.449 9.7157C110.154 9.06913 111.244 7.3716 111.134 5.53051C111.134 1.85349 108.095 0 103.374 0H90.3012L86.1697 5.20205H103.639C104.495 5.20205 105.351 5.50107 105.351 6.48746C105.351 7.50381 104.523 7.83278 103.639 7.83278H86.1697V20H103.521C109.747 20 111.547 17.4886 111.547 14.171C111.653 12.1398 110.372 10.2993 108.449 9.71673M103.553 14.8584H92.3129V12.1078H103.553C104.881 12.1078 105.442 12.5866 105.442 13.4526C105.441 14.3796 104.881 14.8584 103.553 14.8584Z"
      fill="currentColor"
    />
    <path
      d="M127.585 0C119.123 0 114.893 3.068 114.893 9.9855C114.893 16.903 119.124 20 127.585 20C136.02 20 140.276 16.903 140.276 9.9855C140.276 3.068 136.02 0 127.585 0ZM127.585 14.9635C122.187 14.9635 120.24 14.152 120.24 9.9855C120.24 5.819 122.186 5.0355 127.585 5.0355C132.984 5.0355 134.93 5.8175 134.93 9.9855C134.93 14.1535 132.984 14.9635 127.585 14.9635Z"
      fill="currentColor"
    />
    <path
      d="M147.418 0L143.616 5.20205H152.532V20H158.409V5.20205H165.195L169 0H147.418Z"
      fill="currentColor"
    />
  </svg>
}
